import { useState, type FormEvent } from 'react'
import { ArrowRight, Eye, EyeOff, LockKeyhole } from 'lucide-react'

import { api, jsonBody, setCsrfToken } from '../api'
import type { Locale } from '../i18n'
import type { AuthState } from '../types'
import { AuthLayout } from './AuthLayout'

export function LegacyLoginPage({ locale, setLocale, go }: { locale: Locale; setLocale: (locale: Locale) => void; go: (path: string) => void }) {
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault(); setBusy(true); setError('')
    try {
      const data = Object.fromEntries(new FormData(event.currentTarget))
      const result = await api<AuthState>('/api/auth/login', { method: 'POST', body: jsonBody(data) })
      setCsrfToken(result.csrfToken)
      go(result.user.role === 'admin' ? '/app/admin' : '/app')
    } catch (caught) { setError(caught instanceof Error ? caught.message : 'Request failed.') } finally { setBusy(false) }
  }
  const showLabel = showPassword ? (locale === 'en' ? 'Hide password' : '隐藏密码') : (locale === 'en' ? 'Show password' : '显示密码')
  return <AuthLayout locale={locale} setLocale={setLocale} go={go}>
    <form className="auth-form" onSubmit={submit}>
      <span className="auth-symbol"><LockKeyhole /></span>
      <h1>{locale === 'en' ? 'Password sign in' : '账号密码登录'}</h1>
      <p>{locale === 'en' ? 'For team members, verified email accounts and administrators.' : '适用于团队成员、已验证邮箱账号与管理员。'}</p>
      {error && <div className="alert alert-error" role="alert">{error}</div>}
      <label>{locale === 'en' ? 'Email' : '邮箱'}<input name="email" type="email" aria-label="Email" autoComplete="email" required /></label>
      <label>{locale === 'en' ? 'Password' : '密码'}<span className="password-field"><input name="password" type={showPassword ? 'text' : 'password'} aria-label="Password" autoComplete="current-password" minLength={12} required /><button type="button" aria-label={showLabel} aria-pressed={showPassword} title={showLabel} onClick={() => setShowPassword(value => !value)}>{showPassword ? <EyeOff /> : <Eye />}</button></span></label>
      <button className="button button-primary button-submit" disabled={busy}>{busy ? (locale === 'en' ? 'Loading...' : '加载中...') : (locale === 'en' ? 'Sign in' : '登录')}<ArrowRight size={18} /></button>
      <p className="auth-switch"><a href="/login" onClick={event => { event.preventDefault(); go('/login') }}>{locale === 'en' ? 'Continue with Telegram' : '使用 Telegram 登录'}</a></p>
    </form>
  </AuthLayout>
}
